/**
 * Per-device push choice. The `kothar.device.` prefix is the contract with clearSession(), which
 * keeps these keys across sign-out.
 */
export const DEVICE_STORAGE_PREFIX = "kothar.device.";
const OPT_OUT_KEY = `${DEVICE_STORAGE_PREFIX}pushOptOut`;
const INVITE_DISMISSED_KEY = `${DEVICE_STORAGE_PREFIX}pushInviteDismissed`;

export const devicePushPreferences = {
  isOptedOut: () => localStorage.getItem(OPT_OUT_KEY) === "1",
  setOptedOut: (optedOut) => {
    if (optedOut) localStorage.setItem(OPT_OUT_KEY, "1");
    else localStorage.removeItem(OPT_OUT_KEY);
  },
  isInviteDismissed: () => localStorage.getItem(INVITE_DISMISSED_KEY) === "1",
  dismissInvite: () => localStorage.setItem(INVITE_DISMISSED_KEY, "1"),
};
